<footer
	class="footer"
	[ngClass]="{'footer__lockingbar': isSelectedPolicy}"
>
	<section class="footer__top">
		<section class="footer__top-start">
			<!-- ! TODO: Figure out Geico specific footer -->
			<img
				[src]="footerLogoSrc"
				alt="Brand Logo"
				class="footer__logo-image"
			>
		</section>
		<section class="footer__top-end">
			<p class="footer__copyright"> Copyright &copy; {{ copyrightYear }} Embrace Pet Insurance v{{ version }} </p>
			<section class="footer__links u-margin-top-small">
				<a
					qeBaseLink
					target="blank"
					[href]="privacyPolicyUrl"
					aria-label="Link to privacy policy (New Window)"
					class="footer__links-item n--minimal"
					data-quat="action_footerPrivacyLink"
				>Privacy Policy</a>
				<a
					qeBaseLink
					target="blank"
					href="#"
					(click)="openEmbracePrivacySettings($event)"
					aria-label="Link to privacy settings"
					class="footer__links-item n--minimal"
					data-quat="action_footerPrivacyLink"
				>Privacy Settings</a>
				<a
					qeBaseLink
					target="blank"
					[href]="embracePolicyUrl"
					aria-label="Link to The Embrace Policy and Terms (New Window)"
					class="footer__links-item n--minimal"
					data-quat="action_footerEmbracePolicyLink"
				>The Embrace Policy</a>
			</section>
		</section>
	</section>
	<section class="footer__bottom u-margin-top-medium">
		<p class="footer__disclaimer">
			Pet Health Insurance is administered by Embrace Pet Insurance Agency, LLC (Lic. No 0G89328) and underwritten
			by one of the licensed insurers of American Modern Insurance Group, Inc., including American Modern Home
			Insurance Company d/b/a in CA as American Modern Insurance Company (Lic. No 2222-8), and American
			Southern Home Insurance Company. Coverage is subject to policy terms, conditions, limitations, exclusions,
			underwriting review, and approval, and may not be available for all risks or in all states.
			For full terms and conditions, visit <a href="https://www.embracepetinsurance.com/coverage/embrace-terms" target="_blank">www.embracepetinsurance.com/coverage/embrace-terms</a>
		</p>
		<p class="footer__disclaimer u-margin-top-small">
			Premiums are based on the current age of your pet. Premium may increase due to the age of your pet at renewal.
			Initial premiums may be impacted by the species or breed of your pet. Premium may change based on your home address.
		</p>
		<p class="footer__disclaimer u-margin-top-small">
			*Wellness Rewards is offered as an optional membership plan, non-insurance benefit administered by Embrace Pet Insurance Agency, LLC in the United States.
			Wellness Rewards not available in RI, WI, and ME. &copy; {{ copyrightYear }} American Modern Insurance Group, Inc.
			<span *ngIf="showEnhancedContent">
				<br/>
				<sup>1</sup> North American Pet Health Insurance Association: 2022 State of the Industry Report
				<br/>
				<sup>2</sup> Varies by state
			</span>
		</p>
	</section>
</footer>
